// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-08426de7].mce-last{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}[data-v-08426de7] .mce-toolbar{width:500px;overflow-x:auto}[data-v-08426de7] ::-webkit-scrollbar{height:8px}", ""]);
// Exports
module.exports = exports;
